import clsx from 'clsx';

export const TH = (ps: {
  className?: string;
  onClick?(): void;
  children?: React.ReactNode;
}) => (
  <th
    className={clsx(
      'text-left p-3 text-sm bg-neutral-300 first:rounded-l-md last:rounded-r-md align-top',
      ps.className,
    )}
    onClick={ps.onClick}>
    {ps.children}
  </th>
);
